require('babel-polyfill');
require('whatwg-fetch');
require('url-search-params-polyfill');
require('element-closest');
require('intersection-observer');



// WEBPACK FOOTER //
// ./polyfills.js